import React from 'react';
import clsx from 'clsx';
import { Dropdown, Input, Button } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { linkPrefixes } from '@/constants/urls';

const listItems = (intl, value) => Object.keys(linkPrefixes).map((linkPrefix) => ({
  key: `url_protocol_${linkPrefix.toLowerCase()}`,
  text: intl.formatMessage({ id: `protocol.${linkPrefix.toLowerCase()}` }),
  value: linkPrefixes[linkPrefix],
  active: linkPrefixes[linkPrefix] === value,
}));

const UrlEditor = ({
  autoComplete = 'off',
  autoFocus,
  className,
  dialog,
  disabled,
  error,
  icon,
  maxLength,
  onChange,
  onProtocolChange,
  onProtocolClick,
  placeholder,
  protocol,
  size,
  upward,
  value,
}) => {
  const intl = useIntl();
  const placeholderText = placeholder || intl.formatMessage({ id: 'url.placeholder' });
  return (
    <Input
      error={error}
      autoFocus={autoFocus}
      value={value}
      disabled={disabled}
      className={clsx('aridhia-url-editor', className)}
      autoComplete={autoComplete}
      label={
        dialog ? (
          <Button
            content={protocol}
            onClick={onProtocolClick}
            icon="sync"
            className="aridhia-url-editor-button min-w-95"
          />
        ) : (
          <Dropdown
            className="aridhia-url-editor-dropdown normal"
            value={protocol}
            options={listItems(intl, protocol)}
            onChange={onProtocolChange}
            upward={upward}
          />
        )
      }
      placeholder={placeholderText}
      onChange={onChange}
      fluid
      icon={icon}
      size={size}
      maxLength={maxLength}
    />
  );
};

export default UrlEditor;
